import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "solution-wrap" }
const _hoisted_2 = { class: "solution-banner" }
const _hoisted_3 = ["src"]

import { ref, reactive, onMounted, onActivated, watch } from 'vue'
import ArWechat from '@/components/ArWechat.vue';
import VRSimulation from '@/components/VRSimulation.vue';
import VirtualMuseum from '@/components/VirtualMuseum.vue';
import NavigationGuide from '@/components/NavigationGuide.vue';
import MetaverseView from '@/components/MetaverseView.vue';
import HeadCard from '@/components/common/HeadCard.vue';
import SpatialVision from '@/components/SpatialVision.vue';
import EntertainmentPlan from '@/components/EntertainmentPlan.vue';
import IndustryModel from '@/components/IndustryModel.vue';
import EducationModel from '@/components/EducationModel.vue';
import router from '@/router';
import store from '@/store';
import ContactUs from '@/components/ContactUs2.vue'
import { asynchronousRetrieval } from '@/utils'

// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
const __default__ = {
  name: 'SolutionView'
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loadUrl: any = ref({})

const solutionKeyList = ['jjfa_bg0', 'jjfa_bg1', 'jjfa_bg2', 'spatial_vision', 'ar_wechat', 'vr_simulation', 'virtual_museum', 'navigation_guide', 'metaverse'];
const activeSolutionIndex = ref(1);

const initData = async () => {
  const path: any = JSON.parse(window.sessionStorage.getItem('path') || '{}');
  activeSolutionIndex.value = +path.query.type || store.state.programmeIndex;

  const lastBanner = await asynchronousRetrieval(`webimg/images/solution/${solutionKeyList[activeSolutionIndex.value]}.png`);
  loadUrl.value[solutionKeyList[activeSolutionIndex.value]] = lastBanner;
}

onMounted(async () => {
  await initData();
})

watch(() => store.state.programmeIndex, async(newState: any) => {
  if (newState != activeSolutionIndex.value) {
    activeSolutionIndex.value = newState;
    const lastBanner = await asynchronousRetrieval(`webimg/images/solution/${solutionKeyList[newState]}.png`);
    loadUrl.value[solutionKeyList[activeSolutionIndex.value]] = lastBanner;
    store.state.contactUsTop = null;
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: loadUrl.value[solutionKeyList[activeSolutionIndex.value]]
      }, null, 8, _hoisted_3),
      _createVNode(HeadCard, { activeSolutionIndex: activeSolutionIndex.value }, null, 8, ["activeSolutionIndex"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["solution-content", { 'not-margin': [3, 4].includes(activeSolutionIndex.value) }])
    }, [
      (activeSolutionIndex.value == 3)
        ? (_openBlock(), _createBlock(SpatialVision, { key: 0 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 4)
        ? (_openBlock(), _createBlock(ArWechat, { key: 1 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 5)
        ? (_openBlock(), _createBlock(VRSimulation, { key: 2 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 6)
        ? (_openBlock(), _createBlock(VirtualMuseum, { key: 3 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 7)
        ? (_openBlock(), _createBlock(NavigationGuide, { key: 4 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 8)
        ? (_openBlock(), _createBlock(MetaverseView, { key: 5 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 0)
        ? (_openBlock(), _createBlock(EntertainmentPlan, { key: 6 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 1)
        ? (_openBlock(), _createBlock(IndustryModel, { key: 7 }))
        : _createCommentVNode("", true),
      (activeSolutionIndex.value == 2)
        ? (_openBlock(), _createBlock(EducationModel, { key: 8 }))
        : _createCommentVNode("", true)
    ], 2),
    (_unref(store).state.contactUsTop)
      ? (_openBlock(), _createBlock(ContactUs, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})